// extracted by mini-css-extract-plugin
export default {"bubble":"_2hg27","content":"_2cOWL","triangleWrapper":"_2WDVu","triangle":"_1ndlA"};